module.exports = __webpack_public_path__ + "img/des-1.6b8a7193.jpg";